import { FluentProvider, teamsLightTheme, teamsDarkTheme, teamsHighContrastTheme } from '@fluentui/react-components';
import { useEffect } from 'react';
import { HashRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { app } from '@microsoft/teams-js';
import { useTeamsUserCredential } from '@microsoft/teamsfx-react';
import Privacy from './Privacy';
import TermsOfUse from './TermsOfUse';
import TabConfig from './TabConfig';
import { TeamsFxContext } from '../context';
import config from '../config';
import Launch from './Launch';
import { getLaunchUrlParts, isConfigTab } from '../services';

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
	let { tenantId } = config;

	// Get TenantId if not provided in query string
	if (!isConfigTab()) {
		// Check for specific hosts
		const launchURL = getLaunchUrlParts();

		// Fallback for prj svc tenant - TESTING
		if (launchURL.host.includes('tpgppmch')) {
			tenantId = 'd046153d-c10c-4a43-9c3f-052193846a9a';
		}
	}

	// Save tenantId in local storage for auth start and end redirects
	localStorage.setItem('pppTenantId', tenantId ?? '');

	const { loading, theme, themeString, teamsUserCredential } = useTeamsUserCredential({
		initiateLoginEndpoint: config.initiateLoginEndpoint,
		clientId: config.clientId!,
	});

	useEffect(() => {
		loading &&
			app.initialize().then(() => {
				// Hide the loading indicator.
				app.notifySuccess();
			});
	}, [loading]);

	return (
		<TeamsFxContext.Provider value={{ theme, themeString, teamsUserCredential }}>
			<FluentProvider
				theme={
					themeString === 'dark'
						? teamsDarkTheme
						: themeString === 'contrast'
						? teamsHighContrastTheme
						: {
								...teamsLightTheme,
								colorNeutralBackground3: '#F5F5F5',
						  }
				}
			>
				<Router>
					{!loading && (
						<Routes>
							<Route path='/privacy' element={<Privacy />} />
							<Route path='/termsofuse' element={<TermsOfUse />} />
							<Route path='/launch' element={<Launch />} />
							<Route path='/config' element={<TabConfig />} />
							<Route path='*' element={<Navigate to={'/launch'} />}></Route>
						</Routes>
					)}
				</Router>
			</FluentProvider>
		</TeamsFxContext.Provider>
	);
}
